import { http } from '@/providers/apis/http';
import { contentSerializer } from '@/providers/serializers/content-ingestion/content-ingestion';



export class ContentAPI {

    private static INSTANCE = new ContentAPI();

    static get instance() {
      return this.INSTANCE;
    }

    private authNamespace: string = 'api/nucleus-auth';

    private mcNamespace: string = 'api/missioncontrol';

    private namespaceAdmin: string = 'api/v1/admin-utils/learning-registry';

    private namespace: string = 'api/learning-registry/v1';


      // nucleus-media/v1/uploads
      public updateUploadFile(file: any) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('entity_type', 'content');
        const headers = http.getTokenHeaders();
        const endpoint = `api/nucleus-media/v1/uploads`;
        return http.postFile(endpoint, headers, formData);
      }

      // content-ingest-requests-upload
      public uploadFile(data: any) {
        const headers = http.getTokenHeaders();
        const endpoint = `api/v1/content-ingest-requests`;
        return http.post(endpoint, headers, data);
      }

      // content-ingest-requests
      public uploadsContentRequest(filters: any) {
        const headers = http.getTokenHeaders();
        const endpoint = `api/v1/content-ingest-requests`;
        return http.get(endpoint, headers, filters).then((response) => {
          return contentSerializer.uploadModelSerializer(response.data, 'resource');
        });
      }

      // content-ingest-items
      public uploadFileItems(filters: any) {
        const headers = http.getTokenHeaders();
        const endpoint = `api/v1/content-ingest-items`;
        return http.get(endpoint, headers, filters).then((response) => {
         return contentSerializer.uploadModelItemsSerializer(response.data);
       });
      }
      public fetchProductList(params: any) {
        const endpoint = `${this.namespaceAdmin}/content/registry/list`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers, params).then((response) => {
         return contentSerializer.serializeContentProviderList(response.data);
        }).catch((error: any) => {
          return { message: 'error' };
        });
      }
      public savePublisher(publisherInfo: any): Promise<any[]> {
        const endpoint = `${this.namespace}/publishers`;
        const headers = http.getTokenHeaders();
        publisherInfo.website = 'prodb.gooru.org';
        return http.post(endpoint, headers, publisherInfo).then((response) => {
          return response.data;
        }).catch((error: any) => {
          return { message: 'error' };
        });
      }
      public questionUploadFile(file: any, token: any) {
        const headers = {
          Authorization: `Bearer ${token}`,
        };
        const endpoint = `api/v1/content/bulk/ingestion/questions`;
        return http.postFile(endpoint, headers, file).then((res) => {
          return res;
        }).catch((error: any) => {
          return error;
        });
      }
      public getQuestionList(params: any) {
        const headers = http.getTokenHeaders();
        const endpoint = `api/v1/content/bulk/ingestion/questions`;
        return http.get(endpoint, headers, params).then((response) => {
          return contentSerializer.uploadModelSerializer(response.data, 'question');
        });
      }
      public CourseIngestion(file: any) {
        const headers = http.getTokenHeaders();
        const endpoint = `api/v1/course-ingest-requests`;
        return http.post(endpoint, headers, file).then((res) => {
          return res;

        }).catch((error: any) => {
          return error;
        });
      }
      public getCourseList(params: any) {
        const headers = http.getTokenHeaders();
        const endpoint = `api/v1/course-ingest-requests`;
        return http.get(endpoint, headers, params).then((response) => {
          return contentSerializer.uploadModelSerializer(response.data, 'course');
        });
      }
      public ResourceIngestJob(params: any) {
        const headers = http.getTokenHeaders();
        const endpoint = `api/v1/jobs/collection/create`;
        return http.get(endpoint, headers, params).then((response) => {
          return response.data;
        });
      }

    }


export const contentAPI = ContentAPI.instance;

